import { useEffect, useRef, useState } from "react";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { clienteDb } from "../utils/clienteAuth";
import { useStoreDialog } from "../hooks/useStoreDialog";
import { ChatPedido } from "./ChatPedido";

// Conversa livre do cliente com a loja (fora de um pedido). O doc é
// users/{vendedor}/conversas_loja/{uid do cliente}: um por cliente por loja.
const caminhoConversa = (vendedorId, authUid) => `users/${vendedorId}/conversas_loja/${authUid}`;

// true quando a loja respondeu e o cliente ainda não abriu a conversa.
export function useChatLojaNaoLido(vendedorId, authUid) {
  const [naoLido, setNaoLido] = useState(false);
  useEffect(() => {
    if (!vendedorId || !authUid) { setNaoLido(false); return; }
    return onSnapshot(
      doc(clienteDb, caminhoConversa(vendedorId, authUid)),
      snap => setNaoLido(!!snap.data()?.naoLidoCliente),
      () => setNaoLido(false)
    );
  }, [vendedorId, authUid]);
  return naoLido;
}

export function ChatLojaDialog({ vendedorId, nomeLoja, cliente, naoLido, onClose }) {
  const dialogRef = useRef(null);
  const authUid = cliente?.authUid;
  useStoreDialog(dialogRef, true, onClose);

  // Abrir a conversa (ou receber resposta com ela aberta) marca como lida.
  useEffect(() => {
    if (!naoLido || !authUid) return;
    updateDoc(doc(clienteDb, caminhoConversa(vendedorId, authUid)), { naoLidoCliente: false }).catch(() => {});
  }, [naoLido, vendedorId, authUid]);

  if (!authUid) return null;
  return (
    <div className="store-chat-overlay" onClick={onClose}>
      <div ref={dialogRef} className="store-chat-dialog" role="dialog" aria-modal="true" aria-label={`Conversa com ${nomeLoja}`} tabIndex={-1} onClick={e => e.stopPropagation()}>
        <div className="store-chat-head">
          <div>
            <strong>💬 {nomeLoja}</strong>
            <small>Sua mensagem chega direto pro vendedor.</small>
          </div>
          <button type="button" aria-label="Fechar conversa" onClick={onClose}>✕</button>
        </div>
        <ChatPedido
          vendedorId={vendedorId}
          pedidoId={authUid}
          autor="cliente"
          colecao="conversas_loja"
          clienteInfo={{ uid: authUid, nome: cliente.nome || "" }}
          altura={320}
        />
      </div>
    </div>
  );
}
